import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Avatar, Divider } from "@mui/material";
import ProfilesList from "examples/Lists/ProfilesList";
import team3 from "assets/images/team-2.jpg";
import profilesListData from "layouts/profile/data/profilesListData";
import { useEffect } from "react";
import { getNotifications } from "services/apiService";
import MDAvatar from "components/MDAvatar";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { getUserList } from "services/apiService";
import { borderRadius } from "@mui/system";

function Chats() {
  let navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [suggestionList, setSuggestionList] = useState([]);
  const [suggestionLoader, setSuggestionLoader] = useState(true);
  const [suggestionUpdate, setSuggestionUpdate] = useState(false);

  const chatData = [
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
    {
      name: "alex",
      msg: "this is test message",
      pic: "https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS",
    },
  ];

  // const notificationStatements = {
  //   Like: "liked your post",
  //   Comment: "commented on your post",
  //   Following: "started following you",
  // };

  // useEffect(() => {
  //   fetchNotifications();
  //   fetchSuggestionsList();
  // }, []);

  // const fetchNotifications = async () => {
  //   const getNotificationsRes = await getNotifications(0);
  //   console.log("getNotificationsRes", getNotificationsRes);
  //   setNotifications(getNotificationsRes);
  // };

  // const fetchSuggestionsList = async () => {
  //   setSuggestionLoader(true);
  //   const getUserListRes = await getUserList();
  //   console.log("getUserListRes", getUserListRes.user);
  //   setSuggestionList(getUserListRes.user.slice(0, 4));
  //   setSuggestionLoader(false);
  // };

  // const handleUsernameClick = (username) => {
  //   navigate(`/profile/?username=${username}`);
  // };

  // const handleNavigatePost = (postId) => {
  //   navigate(`/post-details/?p_source=${postId}`);
  // };

  // const suggestionListUpdate = () => {
  //   setSuggestionUpdate((prev) => !prev);
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} sx={{ paddingTop: 0 }}>
        <MDBox mt={4.5} sx={{ height: "100%" }}>
          <Grid container justifyContent="center">
            <Grid container item xs={12} md={9} lg={9} border="1px solid grey">
              <Grid item xs={5}>
                <Card sx={{ height: "600px", borderRadius: 0 }}>
                  <MDBox sx={{ height: "100px", border: "1px solid grey" }}>
                    <MDTypography fontSize="15px">
                      Chaitanya Prabhu
                    </MDTypography>
                  </MDBox>

                  <MDBox sx={{ overflowY: "scroll" }}>
                    {chatData.map((item, idx) => (
                      <MDBox
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <MDAvatar
                          src={item.pic}
                          sx={{
                            cursor: "pointer",
                            width: "3rem",
                            height: "3rem",
                          }}
                          imgProps={{
                            style: { height: "100%", width: "100%" },
                          }}
                        />
                        <MDBox>
                          <MDTypography fontSize="12px">
                            {item.name}
                          </MDTypography>
                          <MDTypography fontSize="12px">
                            {item.msg}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ))}
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={7}>
                <Card sx={{ height: "600px", borderRadius: 0 }}>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: "50px",
                      border: "1px solid grey",
                    }}
                  >
                    <MDAvatar
                      src="https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS"
                      sx={{
                        cursor: "pointer",
                        width: "2rem",
                        height: "2rem",
                      }}
                      imgProps={{
                        style: { height: "100%", width: "100%" },
                      }}
                    />
                    <MDTypography fontSize="15px">
                      Chaitanya Prabhu
                    </MDTypography>
                  </MDBox>

                  <MDBox sx={{}}>
                    <MDTypography>Testing</MDTypography>
                    <MDTypography>Testing</MDTypography>
                    <MDTypography>Testing</MDTypography>
                    <MDTypography>Testing</MDTypography>
                    <MDTypography>Testing</MDTypography>
                    <MDTypography>Testing</MDTypography>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Chats;
